/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';
import useOnMutationSettled from './useOnMutationSettled';

function useRefetchOnModalMutation(
  isOpen: boolean,
  mutationFlags: Array<boolean | undefined>,
  refetch: () => void,
): void {
  const mutationCountRef = useRef<number>(0);
  const mutationAtOpenRef = useRef<number>(0);
  const wasOpenRef = useRef<boolean>(false);

  useOnMutationSettled(mutationFlags, () => {
    mutationCountRef.current += 1;
  });

  useEffect(() => {
    if (isOpen && !wasOpenRef.current) mutationAtOpenRef.current = mutationCountRef.current;

    if (wasOpenRef.current && !isOpen && mutationCountRef.current !== mutationAtOpenRef.current) {
      refetch();
    }

    wasOpenRef.current = isOpen;
  }, [isOpen]);
}

export default useRefetchOnModalMutation;
